/**
 * 编辑回看视频信息
 * Create by liaokai on 2020-06-19 16:08:17
 */
import * as React from 'react';
import {Component} from "react";
import {Input, message, Modal} from "antd";
import {TitleContentTable} from "../../../../meeting-list/meeting/menu/lecturer/preview/title-content-table/title-content-table";
import {emailAddressUpdate} from "../../../../../../common/apis/apis/email/emailAddressUpdate";
interface IEmailAddressItem {
    "id": number,
    "name": string,
    "email": string,
}
const defaultItem : IEmailAddressItem = {
    "id": 0,
    "name": "",
    "email": "",
}

interface IProps{
    visible : boolean
    onCancel? : () => void
    onSubmit? : () => void
    storeItem?: IEmailAddressItem
}

interface IState{
    storeItem : IEmailAddressItem
}

export class EmailEditAddress extends Component<IProps,IState>{
    readonly state : IState = {
        storeItem : defaultItem
    };

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        if(JSON.stringify(this.props.storeItem) !== JSON.stringify(prevProps.storeItem) ){
            this.setState({storeItem : this.props.storeItem ?? defaultItem})
        }
    }

    render() {
        let {storeItem} = this.state;
        let {onCancel,onSubmit,visible} = this.props;
        return (
            <Modal
                visible={visible}
                onCancel={()=>{
                    onCancel?.();
                }}
                onOk={()=>{
                    emailAddressUpdate(storeItem as any).then(()=>{
                        onSubmit?.()
                        onCancel?.()
                    }).catch(e => {
                        message.error("保存失败 " + e.data?.message)
                    })
                }}
                cancelText={"取消"}
                okText={"保存"}
                title={"编辑"}
            >
                <TitleContentTable colGap={10} rowGap={10}>
                    <div>姓名</div>
                    <Input placeholder={"请输入姓名"} value={storeItem.name}  onChange={e => {
                        storeItem.name = e.target.value
                        this.setState({storeItem : storeItem})
                    }}/>
                    <div>邮箱</div>
                    <Input placeholder={"请输入邮箱"}  value={storeItem.email} onChange={e => {
                        storeItem.email = e.target.value
                        this.setState({storeItem : storeItem})
                    }}/>
                </TitleContentTable>
            </Modal>
        );
    }
}
